import { UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC } from 'react';

import styles from './CardDescription.css';

type CardDescriptionProps = {
  rowsAmount?: number;
  description: string;
};

export const CardDescription: FC<CardDescriptionProps> = props => {
  const { description, rowsAmount } = props;

  return (
    <div
      className={clsx(styles['container'], !!rowsAmount && styles[`rows-${rowsAmount}`])}
      data-testid="card.description"
    >
      <UIText2 as="p">{description}</UIText2>
    </div>
  );
};
